import { Fragment, Suspense, lazy } from "react";
import { MuiThemeProvider, CssBaseline } from "@material-ui/core";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import theme from "./utils/theme";
import './App.css';
import { getPhantomWallet, getLedgerWallet, getSolflareWallet, getSolletWallet, getSolletExtensionWallet, getSlopeWallet } from '@solana/wallet-adapter-wallets';
import { WalletProvider, ConnectionProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import {
  clusterApiUrl
} from '@solana/web3.js';

require('@solana/wallet-adapter-react-ui/styles.css');

const wallets = [
  /* view list of available wallets at https://github.com/solana-labs/wallet-adapter#wallets */
  getPhantomWallet(),
  // getLedgerWallet(),
  getSolflareWallet(),
  getSolletWallet(),
  getSolletExtensionWallet(),
  getSlopeWallet()
]

let endpoint = "";

if (process.env.REACT_APP_NETWORK_NAME === "mainnet-beta") {
  endpoint = "https://spring-patient-silence.solana-mainnet.quiknode.pro/bc07c01b2733e4e879726ce0efa5b5f4b9d4d06c/"
} else {
  endpoint = clusterApiUrl(process.env.REACT_APP_NETWORK_NAME);
}

const MainComponent = lazy(() => import("./components/Main"));

function App() {
  return (

    <Router>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Suspense fallback={<Fragment />}>
          <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
              <WalletModalProvider>
                <Switch>
                  <Route>
                    <MainComponent />
                  </Route>
                </Switch>
              </WalletModalProvider>
            </WalletProvider>
          </ConnectionProvider>
        </Suspense>
      </MuiThemeProvider>
    </Router>

  );
}

export default App;
